"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RENEWAL_SIC_CODES = void 0;
exports.RENEWAL_SIC_CODES = [
    '5511', // NEW AND USED CAR DEALERS
    '4213', // TRUCKING, EXCEPT LOCAL
    '8742', // MANAGEMENT CONSULTING SERVICES
    '5812', // EATING PLACES
    '7361', // EMPLOYMENT AGENCIES
    '4215', // COURIER SERVICES, EXCEPT BY AIR
    '7011', // HOTELS AND MOTELS
    '7311', // ADVERTISING AGENCIES
    '4731', // FREIGHT TRANSPORTATION ARRANGEMENT
    '5311', // DEPARTMENT STORES
];
